'use strict';

module.exports = '3.27.1';



//////////////////
// WEBPACK FOOTER
// ./~/algoliasearch/src/version.js
// module id = 36
// module chunks = 0